import { render, staticRenderFns } from "./YourCountOfAssignedResponsibilitiesDashboardCard.vue?vue&type=template&id=679184d7&scoped=true"
import script from "./YourCountOfAssignedResponsibilitiesDashboardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./YourCountOfAssignedResponsibilitiesDashboardCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourCountOfAssignedResponsibilitiesDashboardCard.vue?vue&type=style&index=0&id=679184d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679184d7",
  null
  
)

export default component.exports